<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Driftstatus</h1>
    <div class="comp-header__actions">
      <button [admRequiresFeatureRole]="roles['incident-report.download']" mat-button (click)="openDownloadIncidentReport()">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
        Hent rapport
      </button>
      <button [admRequiresFeatureRole]="roles['incident.report']" mat-raised-button color="primary" (click)="openCreateIncidentDialog()">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        Anmeld fejl
      </button>
    </div>
  </div>

  <div class="comp-header__queries" autocomplete="off">
    <adm-text-search placeholder="ID eller lokation" (search$)="querySearchInput($event)" [searchText]="state.filters().query ?? ''" />
    <adm-admin-enum-select-list
      label="Oprettet af"
      (enumChanged)="updateCreatedBy($event)"
      [enumObject]="createdBySelections"
      [translatePipe]="createdByPipe"
      [initialValue]="state.filters().createdBy" />
    <adm-admin-enum-select-list
      label="Status"
      (enumChanged)="updateStatus($event)"
      [enumObject]="statusSelections"
      [translatePipe]="statusPipe"
      [initialValue]="state.filters().status" />
    <adm-org-typeahead
      [initialId]="state.filters().organizationId ?? undefined"
      [resetTrigger]="state.resetOrgFilterSignal()"
      (itemSelected)="organizationSelected($event)" />
    <button (click)="state.resetFilter()" class="comp-header__reset-button" mat-stroked-button>Nulstil</button>
  </div>
</div>

<div class="comp-main incidents">
  <adm-incident-list />
</div>
